import { PropertyPageQuery } from 'gql/graphql'
import { ReactChild } from 'data/types/types'
import { BathroomIcon, BedroomIcon, GuestsIcon, HouseSizeIcon } from 'components/icons'

const PropertyDescriptionSection = ({
  property,
}: {
  property: PropertyPageQuery['property']
}) => {
  if (!property) {
    return null
  }

  return (
    <div className="flex flex-wrap gap-y-20 md:gap-40 justify-center max-w-[705px] mx-auto">
      {
        property.bedrooms && (
          <PropertyDescriptionSectionIcon
            icon={<BedroomIcon />}
            text={`${property.bedrooms} Bedrooms`}
          />
        )
      }

      {
        property.bathrooms && (
          <PropertyDescriptionSectionIcon
            icon={<BathroomIcon />}
            text={`${property.bathrooms} Bathrooms`}
          />
        )
      }

      {
        property.guests && (
          <PropertyDescriptionSectionIcon
            icon={<GuestsIcon />}
            text={`${property.guests} Guests`}
          />
        )
      }

      {
        property.house_sq && (
          <PropertyDescriptionSectionIcon
            icon={<HouseSizeIcon className="mr-4 text-38" />}
            text={<>{property.house_sq} M<sup>2</sup></>}
          />
        )
      }
    </div>
  )
}

const PropertyDescriptionSectionIcon = ({
  icon,
  text,
}: {
  icon: ReactChild
  text: ReactChild
}) => (
  <div className="flex flex-col items-center w-[145px]">
    <span className="h-45 text-[45px] flex items-center justify-center">
      {icon}
    </span>

    <p className="uppercase tracking-2 mt-15 text-12 leading-14">
      {text}
    </p>
  </div>
)

export default PropertyDescriptionSection
